/* ───────────────────────────────────────────
   NEON SKIES — CAROUSEL CLICK-&-DRAG
   Adds grab-to-scroll on .carousel (mouse / trackpad / pen).
   Touch keeps native momentum scrolling. Works alongside the
   existing scrollCar() arrow buttons. Self-contained.
   ─────────────────────────────────────────── */
'use strict';
(function () {
  var DRAG_THRESHOLD = 6; // px before a press becomes a drag (vs a click)

  // Inject cursor styles + disable native image dragging once.
  (function injectStyle() {
    if (document.getElementById('carousel-drag-style')) return;
    var s = document.createElement('style');
    s.id = 'carousel-drag-style';
    s.textContent =
      '.carousel{cursor:grab;}' +
      '.carousel.is-grabbing{cursor:grabbing;user-select:none;scroll-behavior:auto;}' +
      '.carousel.is-grabbing a,.carousel.is-grabbing img{cursor:grabbing;}' +
      '.carousel img{-webkit-user-drag:none;user-select:none;-webkit-touch-callout:none;}';
    document.head.appendChild(s);
  })();

  function initCarouselDrag(car) {
    if (car.__dragInit) return;
    car.__dragInit = true;

    var isDown = false, moved = false, startX = 0, startScroll = 0, snapPrev = '', activePointer = null;

    // Kill native image/link drag anywhere in the carousel BEFORE it can hijack
    // the pointer. Without this, pressing on an image starts the browser's own
    // drag-and-drop and our scroll logic never receives the move events.
    car.addEventListener('dragstart', function (e) { e.preventDefault(); });

    car.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // let touch scroll natively
      if (e.button !== 0) return;             // left button only
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = car.scrollLeft;
      activePointer = e.pointerId;
      car.classList.add('is-grabbing');
      snapPrev = car.style.scrollSnapType;
      car.style.scrollSnapType = 'none';      // free 1:1 tracking while dragging
      // NOTE: pointer capture is deferred to pointermove (first threshold
      // crossing). Capturing here retargets the follow-up click to the
      // carousel itself, which kills plain clicks on product links.
      // Stop the press from initiating a native image drag.
      if (e.target && e.target.tagName === 'IMG') e.preventDefault();
    });

    car.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > DRAG_THRESHOLD) {
        moved = true;
        // Capture only once a real drag starts so links/images can't steal
        // subsequent move events, while plain clicks stay untouched.
        try { car.setPointerCapture(activePointer != null ? activePointer : e.pointerId); } catch (err) {}
      }
      if (moved) {
        e.preventDefault();
        car.scrollLeft = startScroll - dx;
      }
    });

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;
      car.classList.remove('is-grabbing');
      car.style.scrollSnapType = snapPrev;
      if (moved) {
        // Swallow the click that fires after a real drag so cards/links/+ don't trigger
        var swallow = function (ev) {
          ev.stopPropagation();
          ev.preventDefault();
          car.removeEventListener('click', swallow, true);
        };
        car.addEventListener('click', swallow, true);
        setTimeout(function () { car.removeEventListener('click', swallow, true); }, 0);
      }
      try { if (e && e.pointerId != null) car.releasePointerCapture(e.pointerId); } catch (err) {}
      activePointer = null;
    }

    car.addEventListener('pointerup', endDrag);
    car.addEventListener('pointercancel', endDrag);
  }

  function initAll() {
    document.querySelectorAll('.carousel').forEach(initCarouselDrag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor: re-init when a section is re-rendered
  document.addEventListener('shopify:section:load', initAll);
})();
